/*
 * Copyright (c) 2018. CPP, Inc. All rights reserved.
 * Also protected by Patent Pending: 15/916,593
 */

import PropTypes from 'prop-types'
import { graphql } from 'gatsby'

export const photoNavFragment = graphql`
  fragment PhotoNav on ImageSharpConnection {
    all: edges {
      photo: node {
        fields {
          slug
          title
        }
      }
    }
  }
`

const raw = PropTypes.shape({
  all: PropTypes.arrayOf(
    PropTypes.shape({
      photo: PropTypes.shape({
        fields: PropTypes.shape({
          slug: PropTypes.string.isRequired,
          title: PropTypes.string.isRequired,
        }).isRequired,
      }).isRequired,
    }).isRequired
  ).isRequired,
})

const single = PropTypes.shape({
  slug: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
})

const list = PropTypes.arrayOf(single)

const PhotoNavigationShape = { raw, list, single }

export default PhotoNavigationShape
